let env = process.env.NODE_ENV

// 生产环境为pmphysym，测试环境为ysym
const host = env === 'development' ? 'http://localhost:3001/' : env === 'production' ? '/pmphysym/' : 'http://localhost:8090/'
const serverRoot = env === 'development' ? '/v1/' : env === 'production' ? '/pmphysym/v1/' : ''

let config = {
  env: env,
  host: host,
  serverRoot: serverRoot,
  iosDownload: 'apps.apple.com/cn/app/id1543135681',
  andrDownload: 'rwshop.ipmph.com/web-combine-api/admin-api/web/version/getVersion',
}
export default config



// WEBPACK FOOTER //
// ./src/config/config.js